import Edit from './Edit';
import MyProfile from './MyProfile';

export default {
  show: MyProfile,
  edit: Edit,
};
